'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _constants = require('../constants');
var _snapshot = require('../utils/snapshot');
var _addressLookup = require('./address-lookup');
var _addressLookup2 = _interopRequireDefault(_addressLookup);
var _activeField = require('./active-field');
var _activeField2 = _interopRequireDefault(_activeField);
var _employmentLookup = require('./employment-lookup');
var _employmentLookup2 = _interopRequireDefault(_employmentLookup);
var _errors = require('./errors');
var _errors2 = _interopRequireDefault(_errors);
var _fieldsValidating = require('./fields-validating');
var _fieldsValidating2 = _interopRequireDefault(_fieldsValidating);
var _introducerSelect = require('./introducer-select');
var _introducerSelect2 = _interopRequireDefault(_introducerSelect);
var _submittingField = require('./submitting-field');
var _submittingField2 = _interopRequireDefault(_submittingField);
var _submittingForm = require('./submitting-form');
var _submittingForm2 = _interopRequireDefault(_submittingForm);
var _validAndPristine = require('./valid-and-pristine');
var _validAndPristine2 = _interopRequireDefault(_validAndPristine);
var _values = require('./values');
var _values2 = _interopRequireDefault(_values);
var _vehicleLookup = require('./vehicle-lookup');
var _vehicleLookup2 = _interopRequireDefault(_vehicleLookup);
var _searchableSelect = require('./searchable-select');
var _searchableSelect2 = _interopRequireDefault(_searchableSelect);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
var reducers = {
  addressLookup: _addressLookup2.default,
  activeField: _activeField2.default,
  employmentLookup: _employmentLookup2.default,
  errors: _errors2.default,
  fieldsValidating: _fieldsValidating2.default,
  introducerSelect: _introducerSelect2.default,
  submittingField: _submittingField2.default,
  submittingForm: _submittingForm2.default,
  validAndPristine: _validAndPristine2.default,
  values: _values2.default,
  vehicleLookup: _vehicleLookup2.default,
  searchableSelect: _searchableSelect2.default
};
var createForm = function createForm(state, action) {
  return Object.keys(reducers).reduce(function (acc, curr) {
    return Object.assign({}, acc, _defineProperty({}, curr, reducers[curr](state ? state[curr] : undefined, action)));
  }, {});
};
exports.default = function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];
  var formId = action.meta && action.meta.formId ? action.meta.formId : action.formId;
  if (!formId) {
    return state;
  }
  var snapshot = typeof action.snapshot !== 'undefined' ? action.snapshot : false;
  switch (action.type) {
    case _constants.actionTypes.POPULATE_FORM:
      {
        var _Object$assign2;
        return Object.assign({}, state, (_Object$assign2 = {}, _defineProperty(_Object$assign2, formId, createForm(action.form, action)), _defineProperty(_Object$assign2, (0, _snapshot.getSnapshotFormId)(formId), snapshot ? createForm(action.form, action) : undefined), _Object$assign2));
      }
    case _constants.actionTypes.CREATE_SNAPSHOT:
      {
        return Object.assign({}, state, _defineProperty({}, (0, _snapshot.getSnapshotFormId)(formId), createForm(state[formId], action)));
      }
    case _constants.actionTypes.RESET_FORM:
      {
        return Object.assign({}, state, _defineProperty({}, formId, createForm(snapshot ? state[(0, _snapshot.getSnapshotFormId)(formId)] : undefined, action)));
      }
    default:
      return Object.assign({}, state, _defineProperty({}, formId, createForm(state[formId], action)));
  }
};